<div class="quick-task" *ngIf="canCreate">
  <button
    type="button"
    class="quick-task__trigger"
    [matMenuTriggerFor]="quickTaskMenu"
    (menuOpened)="ensureAssignees()"
    (menuClosed)="onMenuClosed()"
    matTooltip="Create a task"
    matTooltipPosition="below"
    aria-label="Create a task">
    <span class="quick-task__label">Create Task</span>
  </button>

  <mat-menu
    #quickTaskMenu="matMenu"
    [class]="'quick-task-panel'"
    xPosition="before"
    [overlapTrigger]="false">
    <!-- Clicks inside the panel must not fall through to the trigger/backdrop. -->
    <div
      class="qt-panel"
      (click)="$event.stopPropagation()"
      (keydown)="$event.key !== 'Escape' && $event.stopPropagation()">
      <!-- Capture -->
      <ng-container *ngIf="panelMode === 'form'">
        <div class="qt-panel__head">
          <div class="qt-panel__title">New task</div>
          <div class="qt-panel__subtitle">Added to this fund's board</div>
        </div>

        <form class="qt-panel__body" [formGroup]="form" (ngSubmit)="submit()">
          <label class="qt-field">
            <span class="qt-field__label">Title</span>
            <input
              class="qt-input"
              type="text"
              formControlName="title"
              placeholder="What needs doing?"
              autocomplete="off" />
          </label>

          <label class="qt-field">
            <span class="qt-field__label">Assignee</span>
            <select
              class="qt-input qt-input--select"
              formControlName="assigneeId">
              <option value="" disabled>
                {{ isLoadingTeam ? 'Loading team…' : 'Select someone' }}
              </option>
              <option *ngFor="let assignee of assignees" [value]="assignee.id">
                {{ assignee.label }}
              </option>
            </select>
            <span class="qt-field__hint" *ngIf="teamUnavailable">
              Couldn't load the team — a task needs one assignee.
            </span>
          </label>

          <div class="qt-field">
            <span class="qt-field__label">Priority</span>
            <div class="qt-priority">
              <button
                *ngFor="let priority of priorities"
                type="button"
                class="qt-priority__option"
                [ngClass]="{
                  'qt-priority__option--low': priority === 'LOW',
                  'qt-priority__option--medium': priority === 'MEDIUM',
                  'qt-priority__option--high': priority === 'HIGH',
                  'qt-priority__option--on': form.value.priority === priority
                }"
                (click)="selectPriority(priority)">
                {{ priority | titlecase }}
              </button>
            </div>
          </div>

          <label class="qt-field">
            <span class="qt-field__label">Due date <em>optional</em></span>
            <input class="qt-input" type="date" formControlName="dueAt" />
          </label>

          <label class="qt-field">
            <span class="qt-field__label">Description <em>optional</em></span>
            <textarea
              class="qt-input qt-input--area"
              rows="3"
              formControlName="description"
              placeholder="Anything the assignee needs to know"></textarea>
          </label>
        </form>

        <div class="qt-panel__foot">
          <button
            type="button"
            class="qt-btn qt-btn--primary"
            (click)="submit()"
            [disabled]="isSubmitting || form.invalid">
            {{ isSubmitting ? 'Creating…' : 'Create task' }}
          </button>
        </div>
      </ng-container>

      <!-- Created — the handoff into the real task -->
      <ng-container *ngIf="panelMode === 'created'">
        <div class="qt-created">
          <div class="qt-created__mark"><mat-icon>check</mat-icon></div>
          <div class="qt-created__title">Task created</div>
          <div class="qt-created__name">{{ createdTitle }}</div>
        </div>

        <div class="qt-panel__foot qt-panel__foot--actions">
          <button
            type="button"
            class="qt-btn qt-btn--ghost"
            (click)="menuTrigger?.closeMenu()">
            Done
          </button>
          <button
            type="button"
            class="qt-btn qt-btn--primary"
            *ngIf="createdTaskId"
            (click)="openCreatedTask()">
            Open task
          </button>
        </div>
      </ng-container>
    </div>
  </mat-menu>
</div>
